/**
 * Use these IDs when creating or cleaning redux-form forms.
 */

export const AEROMEXICO_VACATIONS_FORM_ID = 'aeromexicoVacations';
export const AEROMEXICO_VACATIONS_GROUP_FORM_ID = 'aeromexicoVacationsGroup';
export const BOOKING_USER_HERTZ_PROMOCODES = 'bookingUserHertzPromoCodes';
export const CHECKIN_DETAILS_FORM_ID = 'checkInDetailsAgreements';
export const CHECKIN_TIMATIC_FORM = 'checkInTimaticForm';
export const CHECKIN_TRAVELERS_FORM_ID = 'checkInTraveler';
export const COUPON_FORM_ID = 'coupon';
export const CONTACT_US_CUSTOMER_SERVICE_FORM_ID = 'contactUsCustomerService';
export const CONTACT_US_INVESTOR_RELATIONS_FORM_ID = 'contactUsInvestorRelations';
export const EMAIL_CHECKINMYB_FORM_ID = 'emailCapture';
export const EMAIL_INPUT_FORM_ID = 'emailInput';
export const EMAIL_PNR_INFO_FORM_ID = 'emailPNRInfo';
export const FLIGHT_NOTIFICATIONS_ADD_EMAIL = 'flightNotificationAddEmails';
export const FREQUENT_FLYER_FORM_ID = 'frequentFlyer';
export const HEADER_MENU_QUICKBOOKER = 'headerMenuQuickbooker';
export const INVESTORS_DOWNLOAD_FORM_ID = 'formInvestorsDownload';
export const INVESTORS_SUSCRIBE_FORM_ID = 'investorsSuscribe';
export const MANAGE_TRAVELERS_FORM_ID = 'manageTravelers';
export const PAYMENT_FORM_ID = 'payment';
export const PNR_LOOKUP_FORM_ID = 'pnrLookup';
export const PROFILE_LOGIN_FORM_ID = 'profileLogin';
export const PROFILE_SIGNUP_FORM_ID = 'profileSignup';
export const SELECT_TRAVELERS_FORM_ID = 'selectTravelers';
export const TRAVELERS_FORM_ID = 'traveler';
export const TRAVELERS_SAVED_ID = 'travelerSaved';
export const USER_PROFILE_ADD_CREDIT_CARD_FORM_ID = 'userProfileAddCreditCard';
export const USER_PROFILE_ADD_GIFT_CARD_FORM_ID = 'userProfileAddGiftCard';
export const USER_PROFILE_ADD_NEW_TRIPS = 'userProfileAddNewTrips';
export const USER_PROFILE_EDIT_ADDITIONAL_DETAILS_FORM_ID = 'userProfileEditAdditionalDetails';
export const USER_PROFILE_EDIT_CHECK_IN_DETAILS_FORM_ID = 'userProfileEditCheckInDetails';
export const USER_PROFILE_EDIT_CONTACT_DETAILS_FORM_ID = 'userProfileEditContactDetails';
export const USER_PROFILE_EDIT_CREDIT_CARD_FORM_ID = 'userProfileEditCreditCard';
export const USER_PROFILE_EDIT_FFPROGRAMS_FORM_ID = 'userProfileEditFFPrograms';
export const USER_PROFILE_EDIT_GIFT_CARD_FORM_ID = 'userProfileEditGiftCard';
export const USER_PROFILE_EDIT_PERSONAL_DETAILS_FORM_ID = 'userProfileEditPersonalDetails';
export const USER_PROFILE_EDIT_SETTINGS_FORM_ID = 'userProfileEditSettings';
export const USER_PROFILE_EDIT_TRAVELER_FORM_ID = 'userProfileEditTraveler';
export const USER_PROFILE_LOGIN_FORM_ID = 'userProfileLogin';
export const USER_PROFILE_NEW_TRAVELER_FORM_ID = 'userProfileNewTraveler';
export const USER_PROFILE_PASSWORD_PIN_RESET_FORM_ID = 'userProfilePasswordPinReset';
export const USER_PROFILE_RECOVER_PIN_FORM_ID = 'userProfileRecoverPin';
export const USER_PROFILE_SIGNUP_FORM_ID = 'userProfileSignup';
export const USER_PROFILE_UPDATE_CONSENT_FORM_ID = 'userProfileUpdateConsent';
export const VALIDATE_BILL_FORM_ID = 'validateBill';
export const USER_PROFILE_RECOVER_ACCOUNT_FORM_ID = 'userProfileAccountRecovery';